import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/odkup";

export const fetchAnimalsPurchasePage = createAsyncThunk(
  "purchase/animals-page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/zival/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchPurchasePage = createAsyncThunk(
  "purchase/purchase-page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/odkup/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const initialState = {
  page: {},
  animalsPage: {},
  error: null,
  isLoading: false,
};

const purchaseSlice = createSlice({
  name: "purchase",
  initialState: initialState,
  reducers: {
    resetPurchaseState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnimalsPurchasePage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAnimalsPurchasePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.animalsPage = action.payload;
      })
      .addCase(fetchAnimalsPurchasePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchPurchasePage.pending, (state) => {
        state.error = null;
        state.isLoading = true;
      })
      .addCase(fetchPurchasePage.fulfilled, (state, action) => {
        state.page = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPurchasePage.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      });
  },
});

export const { resetPurchaseState } = purchaseSlice.actions;

export default purchaseSlice.reducer;
